import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import { Card, RightAlignedButton } from "../../common_components/Layout";
import { TitleAndText } from "../components/TitleAndText";
import CreationFooter from "../components/CreationFooter";
import { useAlert } from 'react-alert'
import { updatePrice, PriceDisplay } from "../components/PriceDisplay";
import { parseSurveyJson } from "../../common_components/SurveyHelpers";
import { SurveyDetailCard } from "../../missions_components/sub_page_components/SurveyOverviewCard";



// Api Calls
import MissionPriceQuotesAPI from "../../../api/api_calls/MissionPriceQuotesAPI";
import SurveyAPI from "../../../api/api_calls/SurveyAPI";

function ScreenerReview(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);

    const [price, setPrice] = useState(null);

    const [loadingScreener, setLoadingScreener] = useState(true);
    const [surveyJson, setSurveyJson] = useState({});
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [questionCount, setQuestionCount] = useState(-1);
    const [screeningQuestionCount, setScreeningQuestionCount] = useState(-1);
    const [missionType, loadingMissionType, nextPage, backPage] = useOutletContext();




    // const [sessionLength, setSessionLength] = useState(-1);
    // const [numberRespondents, setNumberRespondents] = useState(-1);
    // const [videoRequired, setVideoRequired] = useState(false);
    // const [colleagues, setColleagues] = useState("");

    // const sessionLengthTooltip = "The length of each feedback session."
    // const numberRespondentsTooltip = "The total number of sessions you'd like to have"
    // const videoRequiredTooltop = "Is the respondent required to turn on video for the session?"
    // const colleagesTooltip = "Colleagues that will also receive calendar invites for sessions. They will not automatically be invited to this platform. Type in their emails separated by commas."


    function onClickBack() {
        navigate(backPage, { state: { missionId: missionId } })
    }
    function onClickNext(event) {
        event.preventDefault();
        navigate(nextPage, { state: { missionId: missionId } })

    }

    useEffect(() => {
        async function getScreener() {
            const response = await SurveyAPI.showScreener({ missionId: missionId, handleRedirect: navigate });
            if (response.success) {
                if (response.survey_exists) {
                    setSurveyJson(response.survey_json);
                    setSurveyQuestions(parseSurveyJson(response.survey_json))
                    setQuestionCount(response.question_count);
                    setScreeningQuestionCount(response.screening_question_count);
                    setLoadingScreener(false);
                } else {
                    setSurveyJson({});
                    setQuestionCount(0);
                    setScreeningQuestionCount(0);
                    setLoadingScreener(false);
                }
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        // Set the path for the button if there's a direct link.
        getScreener();
        updatePrice();
    }, [])

    function updatePrice() {
        async function createMissionPriceQuote() {
            const result = await MissionPriceQuotesAPI.create({ missionId, navigate });

            if (result.success) {
                setPrice(result.price);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        createMissionPriceQuote();
    }


    return (
        <Card style={{ flexGrow: 1 }} >
            <div className="session-details-container">
                <TitleAndText title="Screener" text="Optionally create a short screener survey to ensure you reach your target audience." />
                <div className="survey-and-price-container">
                    <SurveyDetailCard loadingSurvey={loadingScreener} questionCount={questionCount} surveyQuestions={surveyQuestions} isScreener={true} />
                    <PriceDisplay title="Response Price" price={price} />
                </div>
                <CreationFooter buttonText="Next" onClickBack={onClickBack} onClickSubmit={onClickNext} submitLoading={submitInProcess} />
            </div>
        </Card>

    )
}



export default ScreenerReview;